export { BackgroundCoreModule } from './background-core.module';
export { BackgroundSelectorComponent } from './background-selector/background-selector.component';
export { BackgroundCoreService } from './background-core.service';
export { IBackground } from './background.interface';
